"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextMixin = void 0;
var _styledComponents = require("styled-components");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _semanticChildrenMixin = require("../semanticChildrenMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var textAlignCss = function textAlignCss(_ref) {
  var textAlign = _ref.textAlign;
  return textAlign ? (0, _styledComponents.css)(["text-align:", ";"], textAlign) : '';
};
var textWrapCss = function textWrapCss(_ref2) {
  var textWrap = _ref2.textWrap;
  return textWrap ? (0, _styledComponents.css)(["text-wrap:", ";"], textWrap) : '';
};

/** @class TextMixin */
/** @method */
var TextMixin = function TextMixin(props) {
  return (0, _styledComponents.css)(["", " ", " ", " margin:0;", " ", ""], (0, _typographyMixin.typographyMixin)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('textAlign', textAlignCss)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('textWrap', textWrapCss)(props), (0, _spacingMixin.spacingMixin)(props), (0, _semanticChildrenMixin.semanticChildrenMixin)(props));
};
exports.TextMixin = TextMixin;